import { AccountProfile } from '#/api/account';

import { AccountProfileState, INITIAL_STATE } from './account-profile-state';

export interface AccountProfileView {
  readonly status: AccountProfileState['status'];
  readonly error: AccountProfileState['error'];
  readonly username: string;
  readonly isUsernamePrivate: boolean;

  // Derived:
  readonly shouldPromptForUsername: boolean;
}

export const EMPTY_VIEW: AccountProfileView = {
  status: INITIAL_STATE.status,
  error: INITIAL_STATE.error,
  username: '-',
  isUsernamePrivate: false,
  shouldPromptForUsername: false,
};

export function createView(state: AccountProfileState): AccountProfileView {
  const { profile } = state;

  if (profile == null)
    return {
      ...EMPTY_VIEW,
      status: state.status,
      error: state.error,
    };

  return {
    status: state.status,
    error: state.error,
    username: profile.username,
    isUsernamePrivate: profile.is_username_private,
    shouldPromptForUsername: shouldPromptForUsernameView(profile),
  };
}

export function shouldPromptForUsernameView(
  accountProfile: AccountProfile,
): boolean {
  if (accountProfile.is_username_private) return false;
  if (accountProfile.username !== '') return false;
  return true;
}
